<ycn-base-autocomplete
    class="input-group field-input-group"
    [appendToBody]="appendToBody"
    [buttonType]="'icon-search'"
    [placeholder]="placeholder"
    [searchType]="searchType"
    [defaultOnly]="defaultOnly"
    (submitHandler)="submitHandler.emit($event)">
</ycn-base-autocomplete>
